export type NetworkError = {
	code: number | null;
	message?: string;
};

export type Network = {
	isFetching: boolean;
	isFetched: boolean;
	isFailed: boolean;
	error: NetworkError;
};
export const networkInitialState: Network = {
	isFetching: false,
	isFetched: false,
	isFailed: false,
	error: {
		code: null,
	},
};

export enum NetworkStatuses {
	REQUEST = 'REQUEST',
	SUCCESS = 'SUCCESS',
	FAILED = 'FAILED',
}

export const getNetworkState = (
	status: keyof typeof NetworkStatuses,
	error?: NetworkError
): Network => {
	switch (status) {
		case NetworkStatuses.REQUEST:
			return {
				isFetching: true,
				isFetched: false,
				isFailed: false,
				error: {
					code: null,
				},
			};
		case NetworkStatuses.SUCCESS:
			return {
				isFetching: false,
				isFetched: true,
				isFailed: false,
				error: {
					code: null,
				},
			};
		case NetworkStatuses.FAILED:
			return {
				isFetching: false,
				isFetched: true,
				isFailed: true,
				error: error || {
					code: null,
					message: 'error',
				},
			};
		default:
			return {
				isFetching: false,
				isFetched: false,
				isFailed: false,
				error: {
					code: null,
				},
			};
	}
};
